// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__zjU8z","content":"RecentSearches_content__2sY5F"};